import React, { useEffect } from "react";
import Layout from "../../components/Layout";
import DataTable from "./calList";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import calStore from "../../stores/calculateStore";
import User from "../../stores/userStore";
import hiStore from "../../stores/calHistoryStore";
import DatePick from "./calDate";
import History from "./calHistory";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Card, CardContent, Divider } from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const use2Styles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

/////////////////////////////////////////
const cal = observer(() => {
  const user = toJS(User).user;
  const list = toJS(calStore).list;
  const lastHisDate = toJS(calStore).lastHisDate;
  const hisList = toJS(hiStore).hisList;
  const noEdit = toJS(hiStore).noEdit;
  const classes = useStyles();
  const classes2 = use2Styles();
  const [value, setValue] = React.useState(0);
  const datelist = toJS(calStore).datelist;
  const lastDay = toJS(hiStore).lastDay;
  const remain = toJS(calStore).remain;

  const getList = async () => {
    await calStore.getList();
  };
  useEffect(() => {
    getList();
  }, [lastHisDate]);

  const getRemain = async () => {
    await calStore.getRemain();
  };
  useEffect(() => {
    getRemain();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const gethisList = async () => {
    await hiStore.getList();
  };
  useEffect(() => {
    gethisList();
  }, []);

  return (
    <Layout>
      <div className={classes.root}>
      <Paper>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="잡비 사용 내역" {...a11yProps(0)} />
          <Tab label="잡비 정산 기록" {...a11yProps(1)} />
        </Tabs>
      </Paper>
      <TabPanel value={value} index={0}>
      <Typography variant="body2" color= 'textSecondary'>* 수입 입력시 '+' 문자를 붙여 입력합니다. ex) '+1000' or '+1,000'<br/>* 지출 입력시 기호 문자없이 입력합니다.  ex) '1000'  or '1,000'<br/>* 정산한 데이터는 추가, 수정, 삭제할 수 없습니다. <br/>* 비고란은 비워서 저장할 수 있습니다. <br />* 정산 시, 시작 날짜와 종료 날짜를 맞추어 검색한 뒤, 정산합니다. <br /><br /></Typography>
        <Card className={classes2.root}>
          <CardContent>
            <DatePick></DatePick>
            <Divider  style={{ margin:"6px" }}/>
            <Typography variant="body1" color="primary" align="right" style={{ fontWeight: "bold", fontSize: "20px" }}>잔액: {remain} 원</Typography>
          </CardContent>
        </Card>
        <br />
        {/* <Typography variant="h6" color="primary">현재 총 잔액: + list[list.length-1] === null ? '0' : {String(list[list.length-1].)} + 원</Typography> */}
        <DataTable user={user} list={list} noEdit={noEdit} lastHisDate={lastHisDate} datelist={datelist} lastDay={lastDay}></DataTable>   
      </TabPanel>
      <TabPanel value={value} index={1}>
      <Typography variant="body2" color= 'textSecondary'>* 원하는 데이터 위 출력 버튼을 누르면 엑셀로 내보낼 수 있습니다. </Typography>
        <History hisList={hisList}></History>
      </TabPanel>    
    </div>
    </Layout>
  );
});

export default cal;